import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_information",
  "use": "icon-project_information-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-project_information\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M8.67,7.8V5.7A.68.68,0,0,1,9.33,5h8a.68.68,0,0,1,.67.7v9.8a.68.68,0,0,1-.67.7h-2v2.1a.68.68,0,0,1-.67.7h-8A.68.68,0,0,1,6,18.3H6V8.5a.68.68,0,0,1,.67-.7ZM10,7.8h5.33v7h1.34V6.4H10ZM8.67,11.3v1.4h4V11.3Zm0,2.8v1.4h4V14.1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol